// @flow
import moment from 'moment';
import _ from 'lodash';
import DateRange from 'common/domain/DateRange';
import HistoryEntry from './HistoryEntry';
import type { HistoryEntryData } from './HistoryEntry';

type HistoryData = {
  entries: HistoryEntryData[];
}

export type MonthData = {
  month: string;
  weeks: HistoryEntry[];
}

export type WeekData = {
  week: {
    from: moment;
    to: moment;
  };
  reach: number;
  listeningTime: number;
}

const MONTH_YEAR_FORMAT = 'MMMM - YYYY';

export default class History {
  entries: HistoryEntry[];

  constructor(entries: HistoryEntry[]) {
    this.entries = entries.sort((a, b) => a.from.diff(b.from));
  }

  isEmpty() {
    return this.entries.length < 1;
  }

  getDateRange(): DateRange | void {
    if (this.entries.length < 1) {
      return undefined;
    }

    return new DateRange({ from: this.entries[0].from, to: this.entries[this.entries.length - 1].to });
  }

  findStartOfWeekFor(date: moment): HistoryEntry | void {
    return this.entries.find(entry => entry.has(date));
  }

  toJSON(): HistoryData {
    return { entries: this.entries.map(e => e.toJSON()) };
  }

  groupByMonth(): MonthData[] {
    const groupedByMonth = _.groupBy(this.entries, datum => datum.from.format(MONTH_YEAR_FORMAT));
    return _.keys(groupedByMonth).map(month => ({ month, weeks: groupedByMonth[month] })).reverse();
  }

  isSame(other: History) {
    if (this === other) {
      return true;
    }

    if (this.entries.length !== other.entries.length) {
      return false;
    }

    return this.entries.every((entry, index) => entry.isSame(other.entries[index]));
  }

  static parse(data: HistoryData) {
    return new History(data.entries.map(e => HistoryEntry.parse(e)));
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/domain/History.js